import { NOTA_CREDITO_EXTERNO_TYPES } from "../constants/nota-credito-externo.types"
import { ActionNCE, NotaCreditoExterno, StateNCE } from "../interfaces/nota-credito-externo.interfaces"


const initialState: NotaCreditoExterno = {
    formCliente: {
        granContribuyente: false,
        fecha: new Date().toISOString().split('T')[0],
        tipoDocumento: '36',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',    
        datosSucursal: [],
        datosDocumento: [],    
        sucursal: '',
        serie:'',
        loadedSucursal: false,
    },

    errorsCliente: {
        granContribuyente: false,
        fecha: '',
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',    
        datosSucursal: null,
        datosDocumento: null,    
        sucursal: '',
        serie:'',
    },
    productos: [],
    formProducto: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        servicioDescuento: false,
        unidadMedida: '59'
    },
    errorsProducto: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: '',
        descuento: '',
        servicio: false,
        exento: false,
        servicioDescuento: false,
        unidadMedida: ''
    },
    modal_editar: false,
    modal_eliminar: false,
    modal_quitarTodo: false,
    modal_emitir: false,
    modal_emitido: false,
    modal_masOpciones: false,
    modal_enviarCorreo: false,
    modal_imprimir: false,
    modal_anular: false,
    modal_anulado: false,
    modal_clienteEncontrado: false,
    clienteEncontrado: null,
    productoEdit: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        servicioDescuento: false,
        unidadMedida: ''
    },
    productoIndex: null,
    calculosGenerales: {
        operaciones: '',
        retencionRenta: '',
        iva: '',
        ivaPercibido: '',
        ivaRenetido: '',
    },
    calculosProducto: {
        neto: '',
        subtotal: '',
        descuento: '',
        total: '',
        iva: ''
    },
    view: 'Formularios',    
    response_Emitir: null,
    response_QRcode: '',
    sucursales: [],
    documentos: [],
    tableProductos: [],
    retencionRenta: true, // true no calculara retencion Renta
    modal_documentoFisico: true,
    documentosFisico: {
        numId: "",
        tipo: "",
        fecha: "",
        monto: ""
    },
    modal_descuento: false,
    formProductoDescuento: {
        conIva: false,
        descripcion: '',
        cantidad: '1',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        servicioDescuento: true,
        unidadMedida: '59'
    },
    formObservaciones: {
        referencia: '',
        observaciones: '',
        mostrarObservacionesPdf: true,
        incluirObservacionesCorreo: true,
    },
}

const notaCreditoExternoReducer = (
    state: NotaCreditoExterno = initialState,
    action: ActionNCE
): StateNCE => {
    switch (action.type) {
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_FORM_CLIENTE:
            return {...state, formCliente: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_FORM_PRODUCTO:
            return {...state, formProducto: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_HANDLE_ERRORS_CLIENTE:
            return {...state, errorsCliente: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_HANDLE_ERRORS_PRODUCTO:
            return {...state, errorsProducto: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_VIEW:
            return {...state, view: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTOS:
            return {...state, productos: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTO_EDIT:
            return {...state, productoEdit: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTO_INDEX:
            return {...state, productoIndex: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_EDITAR_PRODUCTO:
            return {...state, modal_editar: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_ELIMINAR_PRODUCTO:
            return {...state, modal_eliminar: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_QUITAR_TODO:
            return {...state, modal_quitarTodo: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_EMITIR:
            return {...state, modal_emitir: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_EMITIDO:
            return {...state, modal_emitido: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_MAS_OPCIONES:
            return {...state, modal_masOpciones: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_ENVIAR_CORREO:
            return {...state, modal_enviarCorreo: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_ANULAR:
            return {...state, modal_anular: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_ANULADO:
            return {...state, modal_anulado: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_IMPRIMIR:
            return {...state, modal_imprimir: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_CALCULOS_GENERALES:
            return {...state, calculosGenerales: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_RESTART_FORM_PRODUCTO:
            return {...state, formProducto: initialState.formProducto}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_QR_CODE:
            return {...state, response_QRcode: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_RESPONSE_EMITIR:
            return {...state, response_Emitir: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_CLIENTE_ENCONTRADO:
            return {...state, clienteEncontrado: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_CLIENTE_ENCONTRADO:
            return {...state, modal_clienteEncontrado: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_CALCULOS_PRODUCTO:
            return {...state, calculosProducto: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_TABLE_PRODUCTOS:
            return {...state, tableProductos: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_RETENCION_RENTA:
            return {...state, retencionRenta: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_FORMOBSERVACIONES_HANDLE_CHANGE:
            return {...state, formObservaciones: {...state.formObservaciones, ...action.payload}}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_RESTART_ALL:
            return {...initialState, productos: [], formCliente: initialState.formCliente}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_DOCUMENTO_FISICO:
            return {...state, modal_documentoFisico: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_DOCUMENTO_FISICO: 
            return {...state, documentosFisico: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_DESCUENTO:
            return {...state, modal_descuento: action.payload, formProductoDescuento: initialState.formProductoDescuento}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTO_DESCUENTO:
            return {...state, formProductoDescuento: action.payload}
        case NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTOS_CHANGE_IVA: 
            return {...state, productos: state.productos.map((el) => ({...el, exento: action.payload}))}
        default:
            return state;
    }
}

export default notaCreditoExternoReducer;